import { usePolicyOnDashboard } from '@folio/utils/usePolicyOnDashboard';
import { FinalizeNewBusinessLegacyCard } from './LegacyModule/FinalizeNewBusinessLegacyCard';
import { FinalizeNewBusinessCard } from './FinalizeNewBusinessCard';
import { useFinalizeNewBusinessButtonsFlag } from './useFinalizeNewBusinessButtonsFlag';

export function FinalizeNewBusinessModule() {
  const { policy } = usePolicyOnDashboard();
  const isNewFinalizeNewBusinessEnabled = useFinalizeNewBusinessButtonsFlag(policy.productId);

  if (isNewFinalizeNewBusinessEnabled === undefined) {
    return null;
  }

  return isNewFinalizeNewBusinessEnabled ? (
    <FinalizeNewBusinessCard />
  ) : (
    <FinalizeNewBusinessLegacyCard />
  );
}
